import { render, staticRenderFns } from "./AttachmentSelect.vue?vue&type=template&id=31de2678"
import script from "./AttachmentSelect.vue?vue&type=script&lang=js"
export * from "./AttachmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports